import type { RobinMutationReceipt } from "../robin-types"

/** Maps trusted backend mutation targets to the ATS route opened beside chat. */
export function routeFromMutationReceipt(
  receipt: RobinMutationReceipt,
): string | null {
  const target = receipt.target
  if (!target) return null

  const candidateId =
    target.candidateId ??
    (target.entityType === "candidate" ? target.entityId : undefined)
  const jobId =
    target.jobId ?? (target.entityType === "job" ? target.entityId : undefined)

  if (receipt.type === "comment" && candidateId) {
    const search = new URLSearchParams({
      candidateId,
      commentMode: "view",
      commentId: receipt.id,
    })

    if (jobId) {
      return `/jobs/${encodeURIComponent(jobId)}/pipeline?${search.toString()}`
    }

    return `/candidates?${search.toString()}`
  }

  if (jobId) return `/jobs/${encodeURIComponent(jobId)}/overview`
  if (candidateId) {
    return `/candidates?candidateId=${encodeURIComponent(candidateId)}`
  }

  return null
}
